import { Button } from '@chegg-ui/button'
import * as CardStyles from '@src/components/Cards/styles'
import { Blur as BlurBase } from '@src/layouts/shared/SimilarityScore/styles'
import styled from 'styled-components'
export { InnerContent } from '@src/components/Cards/styles'

export const PlagiarismIcon = styled.img`
  border-radius: 50%;
`

export const UpgradeButton = styled(Button).attrs({ size: 'medium' })`
  margin-bottom: 10px;
  margin-top: 16px;
`

export const V1PlagiarismText = styled.span`
  margin-top: ${({ theme }) => theme.spacing.xl};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: 18px;
  line-height: 22px;
  width: 247px;
  color: ${({ theme }) => theme.colors.dark};
  text-align: center;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.xs};
  height: 300px;
  position: relative;
`

export const CardContainer = styled(CardStyles.CardContainer)`
  justify-content: flex-start;
`

export const CardContent = styled(CardStyles.CardContent)`
  position: absolute;
  top: 0;
  linear-gradient: rgba(255, 255, 255, 1), rgba(255, 255, 255, 0);
`

export const Blur = styled(BlurBase)`
  top: 0;
  height: 360px;
  position: absolute;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 12%
  );
`

export const UpsellContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  z-index: 100;
  width: 300px;
`



// WEBPACK FOOTER //
// ./src/components/PlagiarismLock/styled.tsx